import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import About from '@/pages/About';
import Solutions from '@/pages/Solutions';
import Services from '@/pages/Services';
import Advisory from '@/pages/Advisory';
import Partners from '@/pages/Partners';
import PartnerSolution from '@/pages/PartnerSolution';
// import Blog from '@/pages/Blog';
// import BlogPost from '@/pages/BlogPost';
import Contact from '@/pages/Contact';
import WallixEventRegistration from '@/pages/WallixEventRegistration';
import NotFound from '@/pages/NotFound';
import ScrollToTop from '@/components/ScrollToTop';

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Layout>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/services" element={<Services />} />
          <Route path="/advisory" element={<Advisory />} />
          <Route path="/partners" element={<Partners />} />
          <Route path="/partners/:slug" element={<PartnerSolution />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/events/wallix-partner-enablement" element={<WallixEventRegistration />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Layout>
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
